import { useState } from 'react'
import { Button, Spacing, HalfSpacing, TextboxGroup, RadioGroup, RadioOption } from '@/form/FormComponents'
import { FormProvider, FormSubmitProvider } from '@/form/FormProvider'
import { SignInContainer } from '@/pages/SignedOutLayout'
import { signInAnonymously, signOut } from '@/systems/Authentication'
import { useParams, useNavigate, useLoaderData } from 'react-router'
import { markdown } from 'markdown'

export function JoinStudyLayout() {
  const navigate = useNavigate();
  const join_code = useParams().join_code;
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("terms"); // "terms", "irb", "code"

  const study = useLoaderData().data.value;

  const handleSubmitConsent = function({ formatted_data, focusError }) {
    if (loading) { return; }

    if (formatted_data.consent == "1") {
      setLoading(true);
      submitCode("Opted-out");
    } else {
      setStep("code");
    }
  }

  const handleSubmitName = function({ formatted_data, focusError }) {
    if (loading) { return; }

    let length_errors = (study.code_questions || []).map((q, i) => (q['length'] > 0 && formatted_data.code_questions[i].trim().length !== q['length']) ? q['length'] : false)

    if (length_errors.some(a => a !== false)) {
      focusError({name: "code_questions", error: length_errors.map(a => a ? "Must be "+a+" characters" : false)});
      return;
    }

    setLoading(true);

    let code = formatted_data.code_questions.map(a => a.trim()).join("").toLowerCase();

    submitCode(code);
  }

  function submitCode(code) {
    signOut().then(function() {
      signInAnonymously({ name: code, source_id: "study-"+join_code }).then(function() {

        navigate("/join/"+join_code, { replace: true });

      }).catch(function(error) {
        console.error(error);
        setLoading(false);
      });
    });
  }

  if (step == "terms") {
    return (
      <SignInContainer>
        <div className="setup_title">{study.name}</div>
        <div className="setup_description">You are invited to participate in a research study conducted by {study.organization_name}.<br/><br/>By clicking Continue, you agree to the Sapient Clinician <a href="https://sapientclinician.com/privacy" target="_blank" className="links">Privacy Policy</a> and <a href="https://sapientclinician.com/terms" target="_blank" className="links">Terms of Use</a>. Your data will be shared with the researchers.</div>
        <Spacing/>
        <Spacing/>
        <div className="buttons right">
          <Button text="Continue" className="primary" submit onClick={() => {
            study.consent_form ? setStep("irb") : setStep("code");
          }}/>
        </div>
      </SignInContainer>
    )
  } else if (step == "irb") {
    return (
      <SignInContainer hide_logo={true} loading={loading}>
        <HalfSpacing/>
        <div className="setup_title">Consent Form</div>
        <HalfSpacing/>
        <div className="setup_description markdown collapse_padding" dangerouslySetInnerHTML={{__html: markdown.toHTML(study.consent_form)}}></div>
        {study.consent_options ? <>
          <Spacing/>
          <FormProvider key="study" onSubmit={handleSubmitConsent} obviated={loading}>
            <FormSubmitProvider>
              {({handleSubmit}) => (
                <>
                  <RadioGroup name="consent" required="Please select an option">
                    {study.consent_options.map((option, index) => (
                      <RadioOption key={index} name={String(index)} text={option}/>
                    ))}
                  </RadioGroup>
                  <Spacing/>
                  <div className="buttons right">
                    <Button text="Continue" className="primary" submit onClick={handleSubmit} loading={loading}/>
                  </div>
                </>
              )}
            </FormSubmitProvider>
          </FormProvider>
        </> : <>
          <Spacing/>
          <Spacing/>
          <Spacing/>
          <div className="buttons sides">
            <Button text="Decline" onClick={() => setStep("terms")}/>
            <Button text="I agree" className="primary" submit onClick={() => setStep("code")}/>
          </div>
        </>}
      </SignInContainer>
    )
  } else if (step == "code") {
    return (
      <SignInContainer loading={loading} hide_logo={true}>
        <FormProvider key="study" onSubmit={handleSubmitName} obviated={loading}>
          <FormSubmitProvider>
            {({handleSubmit}) => (
              <>
                <HalfSpacing/>
                <div className="setup_title">{study.code_title || "Create an anonymous login code"}</div>
                <HalfSpacing/>
                <div className="setup_description markdown collapse_padding" dangerouslySetInnerHTML={{__html: markdown.toHTML(study.code_description || "This helps us match your responses across sessions without using your name.")}}></div>
                <Spacing/>
                <HalfSpacing/>
                <TextboxGroup name="code_questions" textboxes={study.code_questions || [{ title: "Your anonymous code" }]} required="This question is required"/>
                <Spacing/>
                <div className="buttons right">
                  <Button text="Submit" className="primary" submit onClick={handleSubmit} loading={loading}/>
                </div>
              </>
            )}
          </FormSubmitProvider>
        </FormProvider>
      </SignInContainer>
    )
  }
}